import './AddAppSection.scss';
import classNames from 'classnames';
import React from 'react';
import { SonarText } from '@ui/text';
export const AddAppSection = ({ children, className, headerExtra, icon, id, title }) => React.createElement("div", { className: classNames('add-app-section', className), id: id },
    React.createElement(SonarText, { className: 'section-header', size: 20, weight: 'semibold' },
        icon,
        title,
        headerExtra && React.createElement("div", { className: 'header-extra' }, headerExtra)),
    children);
